export const UPLOAD_CONCURRENCY = 3;
export const UPLOAD_CHECK_BATCH_SIZE = 20;

/** Bound in-flight work and retain every result, including individual failures. */
export async function mapUploadSettled<T, R>(
  items: readonly T[],
  concurrency: number,
  action: (item: T, index: number) => Promise<R>,
): Promise<PromiseSettledResult<R>[]> {
  const limit = Number.isFinite(concurrency) && concurrency > 0
    ? Math.max(1, Math.floor(concurrency))
    : UPLOAD_CONCURRENCY;
  const results: PromiseSettledResult<R>[] = new Array(items.length);
  let next = 0;
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, async () => {
    while (next < items.length) {
      const index = next++;
      try {
        results[index] = { status: "fulfilled", value: await action(items[index], index) };
      } catch (reason) {
        results[index] = { status: "rejected", reason };
      }
    }
  }));
  return results;
}
